import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
    return (
        <footer>
        <div className="outer-container">
            <div className="inner-container">
                <div className="footer-heading">
                    <h5>Destination</h5>
                    <h5>Regions</h5>
                    <h5>Departing From</h5>
                    <h5>Vacation Types</h5>
                    <h5>Vacation Intersts</h5>
                    <h5>Travel Inspirations</h5>
                </div>
                <div className="footer-social-media">
                    <i className="fab fa-facebook-f"></i>
                    <i className="fab fa-twitter"></i>
                    <i className="fab fa-pinterest-p"></i>
                    <i className="fab fa-linkedin-in"></i>
                    <i className="fab fa-instagram"></i>
                </div>
                <div className="footer-about-us">
                    <h6>About Around The World</h6>
                    <h6>FAQ</h6>
                    <h6>Contact Us</h6>
                    <h6>Reviews</h6>
                    <h6>Press</h6>
                    <h6>Careers</h6>
                    <h6>Terms and Conditions</h6>
                    <h6>Terms of Services</h6>
                </div>
                <div className="services">
                    <h5>Destination</h5>
                    <h5>Regions</h5>
                    <h5>Departing From</h5>
                    <h5>Departing From</h5>
                    <h5>Vacation Types</h5>
                    <h5>Vacation Intersts</h5>
                    <h5>Travel Inspirations</h5>
                </div>
            </div>
        </div>
    </footer>
    );
};

export default Footer;